import jsx from "refractor/lang/jsx.js";
;
export default jsx;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-syntax-highlighter/dist/esm/languages/prism/jsx.js
// module id = 424
// module chunks = 0